const DropdownArrow = () => (
  <svg width={20} height={13} fill="none">
    <path d="m2 2 6.438 8.048a2 2 0 0 0 3.124 0L18 2" stroke="#E0E0E0" strokeWidth={4} />
  </svg>
)

export default DropdownArrow
